import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../icon';
import NotificationsMenu from '../notifications-menu';
import AvatarMenu from '../avatar-menu';
import Link from '../link';

import { Container, Menu, MenuItem, MenuLabel } from './main-menu.css';
import UserService from '../../../services/user-service';

import {
	useUser,
	UserButton
} from '@clerk/clerk-react';

function MainMenu(props) {
	const {
		links,
		queues,
		session,
		onLogout,
		notifications,
		onNotificationsClick,
		isNotificationsActive,
		isMaximized
	} = props;

	const isGuest = UserService.isGuest(session);

	const { user: isClerk } = useUser();

	const [activeLink, setActiveLink] = useState(
		links.find((link) => link.active) || queues.find((queue) => queue.active)
	);

	const renderPageLinks = () => {
		return links.map((link) => {
			return link.enabled && (
				<MenuItem
					key={link.sref}
					isActive={activeLink?.label === link.label}
					data-tooltip={link.label}
					data-tooltip-position="right"
				>
					<Link
						to={{ state: link.sref }}
						data-cy={`menu-${link.sref}`}
						data-testid={`menu-${link.sref}`}
						onClick={() => setActiveLink(link)}
					>
						<Icon use={link.icon} size={1.25} />
						{ !!link.badge && <span className="badge">{link.badge}</span> }
						<MenuLabel>{link.label}</MenuLabel>
					</Link>
				</MenuItem>
			);
		});
	};

	const renderQueueLinks = () => {
		return queues.map((queue, i) => {
			return queue.enabled && (
				<MenuItem
					key={queue.sref}
					isActive={queue.label === activeLink?.label}
					className={cx({ first: i === 0 })}
					data-tooltip={queue.label}
					data-tooltip-position="right"
				>
					<Link
						to={{ state: queue.sref }}
						data-cy={`menu-${queue.sref}`}
						data-testid={`menu-${queue.sref}`}
						onClick={() => setActiveLink(queue)}
					>
						<Icon use={queue.icon} size={1.25} />
						{ !!queue.badge && <span className="badge">{queue.badge}</span> }
						<MenuLabel>{queue.label}</MenuLabel>
					</Link>
				</MenuItem>
			);
		});
	};

	return (
		<Container isMaximized={isMaximized} data-cy="main-menu">
			<Menu>
				{renderPageLinks()}
				{renderQueueLinks()}
			</Menu>

			<div>
				{ !isGuest && <NotificationsMenu
					hasUnread={notifications.badge}
					isActive={isNotificationsActive}
					onMenuItemClick={onNotificationsClick}
				/> }
				{isClerk
					? (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							}}
						>
							<UserButton />
						</div>
					)
					: (
						<AvatarMenu
							onLogout={onLogout}
							session={session}
							isMaximized={isMaximized}
						/>
					)}
			</div>
		</Container>
	);
}

MainMenu.propTypes = {
	links: PropTypes.array.isRequired,
	session: PropTypes.object.isRequired,
	queues: PropTypes.array.isRequired,
	onLogout: PropTypes.func.isRequired,
	notifications: PropTypes.object.isRequired,
	onNotificationsClick: PropTypes.func.isRequired,
	isNotificationsActive: PropTypes.bool.isRequired,
	isMaximized: PropTypes.bool.isRequired
};

MainMenu.methodProps = [
	'onLogout',
	'onNotificationsClick'
];

export default MainMenu;
